import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade } from 'swiper';
import { Autoplay } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');
SwiperCore.use([EffectFade]);

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const list = [
        {
            src: ['kitKSwiper_winter.webp', 'kitKSwiper_winter.jpg'],
        },
        {
            src: ['kitKSwiper_spring.webp', 'kitKSwiper_spring.jpg'],
        },
        {
            src: ['kitKSwiper_summer.webp', 'kitKSwiper_summer.jpg'],
        },
        {
            src: ['kitKSwiper_autum.webp', 'kitKSwiper_autum.jpg'],
        },
    ];

    return (
        <div className={`${css.kitK} kitK`}>
            <div className="kit-ms-box">
                <div className="kit-ms-box-in">
                    <div className="kit-ms1">{t('presale.product.kitK_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.kitK_ms2')}</div>
                </div>
            </div>
            <div className="kit-img1">
                <EFPic name={['kitK1.webp', 'kitK1.jpg']} className="fullImgs" alt={t('presale.product.kitK_ms1')} />
            </div>
            {!['au'].includes(locale) && (
                <>
                    <div className="kit-img2">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={0}
                            initialSlide={0}
                            preloadImages={false}
                            lazy={true}
                            centeredSlides={true}
                            grabCursor={true}
                            pagination={{
                                clickable: true,
                            }}
                            loop
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            effect="fade"
                            className="kit-swiper"
                        >
                            {list?.map((item: any, index: any) => (
                                <SwiperSlide key={index}>
                                    <div className="list-item">
                                        <EFPic name={item.src} className="fullImgs" alt={t('presale.product.kitK_ms1')} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="kit-ms3">{t('presale.product.kitK_ms3')}</div>
                    <div className="kit-ms4">{t(locale === 'kr' ? 'presale.product.kitK_ms4_h5' : 'presale.product.kitK_ms4')}</div>
                </>
            )}
        </div>
    );
}
